module.exports = __webpack_public_path__ + "img/12.75ce4f39.png";